module.exports = Zepto;


//////////////////
// WEBPACK FOOTER
// external "Zepto"
// module id = JJGD
// module chunks = 1